import mixins from './mixins';
import popover from './popover/popover';
import buttonGroup from './button-group/button-group';
import list from './list/list';
import loading from './loading/loading';
import select from './select/select';
import comboBox from './combo-box/combo-box';
import grid from './grid/grid';
import container from './container/container';
import settings from './settings/settings';
import settingsNavigation from './settings/settings-navigation';
import styleBox from './style-box/style-box';
import starRating from './star-rating/star-rating';
import checkBox from './checkbox/checkbox';
import checkBoxGroup from './checkbox/checkbox-group';
import radioButton from './radio-button/radio-button';
import radioButtonGroup from './radio-button/radio-button-group';
import alert from './alert/alert';
import tabMenu from './tab-menu/tab-menu';
import dialog from './dialog/dialog';
import pagination from './pagination/pagination';
import tips from './tips/tips';
import menus from './menus/menus';
import menuButton from './menus/menu-button';

import Vue from 'vue';

const ui = {
    mixins,
    popover,
    buttonGroup,
    list,
    alert,
    loading,
    select,
    comboBox,
    grid,
    container,
    settings,
    settingsNavigation,
    styleBox,
    starRating,
    checkBox,
    checkBoxGroup,
    radioButton,
    radioButtonGroup,
    tabMenu,
    dialog,
    pagination,
    tips,
    menuButton,
    menus
};

Object.keys(ui).forEach(key => {
    Vue.component(ui[key].name, ui[key]);
});
export default ui;
